import {
  AlertType,
  JobFeeFieldNames,
  JobInfoViewActionButtonType,
  PaymentStatus
} from 'constants/enums';

export const SUBSCRIPTION_STATUSES_REQUIRING_UPDATE_PAYMENT_CONFIRM = [
  PaymentStatus.PastDue,
  PaymentStatus.IncompleteExpired
];

export const PRE_FILLED_FEES_FOR_JOB_CONFIGS = {
  [JobFeeFieldNames.OnboardingFee]: 1000,
  [JobFeeFieldNames.RetentionFee]: 2000,
  [JobFeeFieldNames.MonthlyAceFee]: 900,
  [JobFeeFieldNames.DirectHireFee]: 20,
  [JobFeeFieldNames.HourlyMarkupFee]: 1.5,
  [JobFeeFieldNames.FlatRateAmountFee]: 0
};

export const JOB_TYPES_SORT = [
  'FULL_TIME',
  'PART_TIME',
  'SEASONAL',
  'CONTRACTOR'
];

export const REMOTE_JOB_TYPE = 'REMOTE';

/**
 * @attention
 * Not Used!@
 */

export const DOMESTIC_OVERSEAS_SORT = [
  'Domestic',
  'International',
  'Domestic & International'
];

export const YEARS_IN_BUSINESS_SORT = ['1-3', '3-5', '5+', '10+'];
export const FREE_JOBS_AMOUNT = 3;

export const DEFAULT_JOBS_INFO_VIEW_ALERT_SETTINGS = {
  alertType: AlertType.Error,
  alertText: '',
  alertButton: null,
  actionButton: null
};

export const JOBS_INFO_VIEW_ACTION_BUTTON_SETTINGS = {
  retryPayment: {
    key: JobInfoViewActionButtonType.RetryPayment,
    labelKey: 'sidebar.job.retryPayment'
  },
  reactivate: {
    key: JobInfoViewActionButtonType.Reactivate,
    labelKey: 'sidebar.job.reactivate'
  },
  updatePayment: {
    key: JobInfoViewActionButtonType.UpdatePayment,
    labelKey: 'sidebar.job.updatePayment'
  },
  closeJob: {
    key: JobInfoViewActionButtonType.CloseJob,
    labelKey: 'sidebar.job.closeJob'
  }
} as const;

export const JOB_FORM_FIELDS_REQUIRED_FOR_AI_GENERATION = [
  'title',
  ['location', 'city'],
  'workSchedule',
  'salaryFrom',
  'salaryTo',
  'currency',
  'payrollRates'
];
